import React, {Component} from 'react';
import {
    Button, Dropdown,
    Modal, Popup
} from 'semantic-ui-react';
import Alert from "../../components/extras/Alert";

import connect from "react-redux/es/connect/connect";
import {showToast} from "../../actions/ToastAction";
import update from "react-addons-update";
import ProductCompoundData from "../../data/ProductCompoundData";
import {productDialog} from "../../actions/ProductDialogActions";
import {productVariantsDialog} from "../../actions/ProductVariantsDialogActions";
import ProductData from "../../data/ProductData";
import DynamicTable from "../extras/DynamicTable";
import ProductStock from "./ProductStock";
import QuestionDialog from "../extras/QuestionDialog";
import {dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import ProductPricesDialog from "./ProductPricesDialog";
import {productPricesDialog} from "../../actions/ProductPricesDialogActions";
import localDB from "../../data/localDB";
import {selectProduct} from "../../actions/ProductSelectActions";

class IsExists extends Component{
    render(){
        return <span>
            {this.props.variant_parent ? 'No':'Si'}
        </span>
    }
}

class ProductVariantsDialog extends Component {

    constructor() {
        super();

        let more_actions = [
            this.buttonPrices
        ]

        let other_actions_components =[
            this.buttonAddOtherProducts
        ]

        this.state = {
            options: [],
            compound_error: false,
            quantity_error: false,
            data:{
                compound:null,
                quantity:1,
                compound_type:'I'
            },
            table: {
                headers: ['Producto', 'Precio Compra', 'Precio Venta', 'Inventario', 'Es Existente', 'Acciones'],
                name: 'Producto',
                title: 'Productos',
                has_actions: true,
                edit: true,
                can_add: true,
                pagination: false,
                delete: true,
                url: '',
                values: ['id', 'name', 'purchase_price', 'sale_price', 'stock', 'variant_parent'],
                component_fields:[{stock:ProductStock, variant_parent:IsExists}],
                money_fields: ['purchase_price', 'sale_price'],
                more_actions: more_actions,
                other_actions_components: localDB.check_feature('product_variant_exists') ? other_actions_components:[],
                id: 'table_products_variants',
            },
            loading: true,
            loading_add:false,
            other_products_loading: false,
            id: null,
            height: 80,
            modal_other_products_open: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.delete = this.delete.bind(this);
        this.handleCloseModalOtherProducts = this.handleCloseModalOtherProducts.bind(this);
        this.handleOpenModalOtherProducts = this.handleOpenModalOtherProducts.bind(this);
        this.handleSubmitOtherProduct = this.handleSubmitOtherProduct.bind(this);
    }

    buttonPrices = (data) => {
        return <Popup
            trigger={<Button icon='money bill alternate' onClick={()=>this.props.productPricesDialog({id: data.id, name: data.name, is_open:true})}/>}
            content='Precios'
            position='top left'
            key={data.id}
        />;
    }

    buttonAddOtherProducts = () => {
        return <div style={{margin:6}}>
            <Button fluid content='Agregar producto existente' onClick={()=>this.handleOpenModalOtherProducts({})}/>
        </div>;
    }

    loadData() {
        localDB.getDB('products').then(products => {
            let options = products.filter(product => {return product.active === true &&  product.product_type !== 'K' && product.variant_parent === null && product.id !== this.state.id}).map(product => {return {key:product.id, value:product.id, text:product.name}});
            this.setState({options});
        });
    };

    handleSubmitOtherProduct(){
        let data = {
            other_product: this.state.other_product,
            product_id: this.state.id
        }
        this.setState({other_products_loading:true})
        ProductData.addOtherVariant(data, (res) => {
            if (res.save) {
                this.props.selectProduct(res.product);
                this.handleCloseModalOtherProducts();
                this.props.showToast({message: 'Producto Agregado!', type: 'success'});
            }else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                this.setState({disabled_button: false});
            }
            this.setState({other_products_loading:false})
        });
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.modal.id && nextProps.modal.id !== this.state.id){
            let name = update(this.state, {
                table: {
                    url: {
                        $set: `product-variants/${nextProps.modal.id}`
                    }
                }
            });
            this.setState(name);
            this.setState({loading:true, id: nextProps.modal.id});
            this.loadData();
        }
    }

    handleClose = () => {
        this.setState({
            id: null,
            loading: false,
        });
        this.props.productVariantsDialog({
            is_open:false,
            loading:false,
            name:null,
            id:null
        });
    };

    handleCloseModalOtherProducts = () => {
        this.setState({modal_other_products_open: false,});
    };

    handleOpenModalOtherProducts = () => {
        this.setState({modal_other_products_open: true,});
    };

    handleChange = (e, { name, value }) => {
        let data = this.state.data;
        data[name]= value;
        this.setState({data, compound_error:false, quantity_error:false});
    };

    handleTypeChange = (result) => {
        let compound = update(this.state, {
            data: {
                compound_type:  {$set: result},
                compound: {$set: null}
            }
        });
        this.setState(compound);
    };

    handleChangeState = (e, { name, value }) => {
        this.setState({ [name]: value })
    };

    async handleSubmit() {
        if(this.state.data.compound === null){
            this.setState({compound_error:true});
        }else if(this.state.data.quantity <= 0){
            this.setState({quantity_error:true});
        }else {
            let data = this.state.data;
            data.product = this.state.id;
            this.add(data);
        }
    };

    async add(data) {
        this.setState({loading_add:true});
        ProductCompoundData.add(data, (res) => {
            if (res.save) {
                this.props.addCombo(res.data);
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Esta receta ya está en la lista!'
                });
            }
            this.setState({loading_add:false});
        });
    };

    delete(id) {
        ProductData.delete_variant(id, this.state.id, (res) => {
            if (res.delete) {
                this.props.showToast({message: res.message, type: 'success'});
                this.props.dynamicTableDelete(id);
            } else {
                this.props.showToast({message: 'El producto está siendo utilizado!', type: 'error'});
            }
        });
    };

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.productDialog({
                open:true,
                product: {
                    id:null,
                    sale_price:this.props.modal.product.sale_price,
                    purchase_price:this.props.modal.product.purchase_price,
                    active:true
                },
                is_variant:true,
                variant_parent:this.state.id
            })
        }else if(response.event === 'edit'){
            this.props.productDialog({open:true, product:response.data, is_variant:true, variant_parent:this.state.id});
        }else if(response.event === 'delete'){
            this.refs.deleteDialogVariant.open('', response.data.id);
        }
    };

    render() {

        return (
            <div>
                <Modal open={this.props.modal.is_open} dimmer='inverted' size='large' onClose={this.handleClose}>
                    <Modal.Header>{`${this.props.modal.product ? this.props.modal.product.name:''} - Variantes`}</Modal.Header>
                    <Modal.Content image scrolling>
                        <Modal.Description>
                            <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
                <Alert ref='alert'/>
                <QuestionDialog ref="deleteDialogVariant" message="Quitar este producto" callbackConfirm={this.delete}/>
                <ProductPricesDialog />

                <Modal open={this.state.modal_other_products_open} dimmer='inverted' size='mini' onClose={this.handleCloseModalOtherProducts}>
                    <Modal.Header>Seleccionar Producto Existente</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                                <Dropdown
                                    options={this.state.options}
                                    placeholder='Producto'
                                    fluid
                                    name='other_product'
                                    onChange={this.handleChangeState}
                                    search
                                    selection
                                    error={this.state.additional_error}
                                />
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleCloseModalOtherProducts} content="Cerrar"/>
                        <Button primary icon='save' labelPosition='left' disabled={this.state.disabled_button}
                                loading={this.state.disabled_button} onClick={this.handleSubmitOtherProduct}
                                content='Agregar'/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        productVariantsDialog(modal) {
            dispatch(productVariantsDialog(modal))
        },
        showToast(alert) {
            dispatch(showToast(alert));
        },
        productDialog(data){
            dispatch(productDialog(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        productPricesDialog(modal) {
            dispatch(productPricesDialog(modal))
        },
        selectProduct(data) {
            dispatch(selectProduct(data))
        },
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('product_variants_dialog'),
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductVariantsDialog)


// WEBPACK FOOTER //
// ./src/components/inventories/ProductVariantsDialog.js